import React from 'react';

import { DateFormat } from '@aline/common';
import { Grid, Typography } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import type { ReportsListRow } from 'src/components';
import { formatDateForDisplay } from 'src/helpers';

export function ReportsListDateCell({
  value,
}: GridCellParams<ReportsListRow, Date | null>): JSX.Element {
  return (
    <Grid container>
      <Typography variant="body1">{formatDateForDisplay(value, DateFormat.FULL_DATE)}</Typography>
    </Grid>
  );
}
